<div class="popup qo-position-relative">
	<div class="popup-header">
		<h2>{{'FILE_ENTRIES.FILE_MANAGER' | translate}}</h2>
		<qo-toggle-box
			[leftText]="'FILE_ENTRIES.UPLOAD' | translate"
			(leftClicked)="selectedIndex = 1"
			[isLeftActive]="selectedIndex === 1"
			[rightText]="'FILE_ENTRIES.MEDIA_LIBRARY' | translate"
			(rightClicked)="rightClicked()"
		></qo-toggle-box>
	</div>
	<div class="line-wrapper qo-margin-top20 qo-margin-bottom20">
		<div class="qo-position-absolute line"></div>
	</div>
	<div class="popup-body">
		<div
			class="qo-max-width"
			[class.hidden]="selectedIndex !== 1"
		>
			<file-entries
				[withFileSelector]="true"
				(addedFileEntries)="addFiles($event)"
				[fileEntries]="[]"
				[selectedFiles]="uploadedFiles"
				(fileSelected)="fileSelected($event)"
				(fileDeselected)="fileDeselected($event)"
			></file-entries>
		</div>
		<div
			[class.hidden]="selectedIndex !== 2"
			class="qo-max-width"
		>
			<qo-loader *ngIf="isLoading$ | async"></qo-loader>
			<div class="qo-margin-bottom15">
				<qo-toggle-box
					[leftText]="'FILE_ENTRIES.ALL_FILES' | translate"
					(leftClicked)="getFiles(false); selectedFilesIndex = 1;"
					[isLeftActive]="selectedFilesIndex === 1"
					[rightText]="'FILE_ENTRIES.NOT_ATTACHED_FILES' | translate"
					(rightClicked)="getFiles(true); selectedFilesIndex = 2;"
				></qo-toggle-box>
			</div>
			<file-entries
				[edit]="false"
				[fileEntries]="fileEntries$ | async"
				[withFileSelection]="true"
				[selectedFiles]="uploadedFiles"
				(fileSelected)="fileSelected($event)"
				(fileDeselected)="fileDeselected($event)"
			></file-entries>
			<div class="qo-flex-row-center-center">
				<qo-pagination
					[pagination]="pagination$ | async"
					(pageChange)="paginate($event)"
				></qo-pagination>
			</div>
		</div>

	</div>
	<div class="popup-footer">
		<button
			class="qo-button-standard qo-grey"
			(click)="dialog.close()"
		>
			{{'GLOBAL.CLOSE' | translate}}
		</button>
		<button
			class="qo-button-standard qo-primary"
			(click)="save()"
		>
			{{'GLOBAL.SAVE' | translate}}
		</button>
	</div>
</div>
